
export const ticketJsonAndGoKeys = {
	id: "this.ID",
	"company.name": "this_Client_Company.Name",
	statusId: "this.StatusID",
	priority: "this.Priority",
	timeCreated: "this.TimeCreated",
	timeSheduled: "this.TimeSheduled",
	departmentId: "this.DepartmentID",
	subject: "this.Subject",
	"client.email": "this_Client.Email"
} as any;
